import React, { FC, useEffect } from 'react';
import hankPic from 'assets/images/pup-292x374.jpg';

const Donate: FC = () => {

    useEffect(() => {
        document.title = 'How to Donate • Puppies For Parole'
    }, [])

    return (
        <section id="donate">
            <div className="container-lg pt-4 d-lg-flex">
                <div className='col-lg-6 px-lg-3'>
                    <h1 className="font-primary" tabIndex={0}>How To Donate ...</h1>
                    <p className='mb-3'>
                        Puppies for Parole (P4P) operates through our partnerships with animal shelters and animal
                        advocate
                        groups statewide. In Puppies for Parole, selected residents in Missouri prisons have the
                        opportunity to
                        become trainers to rescue dogs. Residents teach dogs basic obedience skills and socialize them,
                        making
                        them more adoptable. Once the dogs have successfully completed the program, they are adopted
                        through
                        their original shelters.
                    </p>
                    <div id="secondaryInfo">
                        <h2 className='small-h2' tabIndex={0}>Benefits to the Community</h2>
                        <ul>
                            <li>Reduces the number of Missouri dogs euthanized and living in animal shelters</li>
                            <li>Gives Missourians a chance to adopt family-friendly dogs</li>
                        </ul>

                        <h2 className='small-h2' tabIndex={0}>Benefits to Resident Dog Handlers</h2>
                        <ul>
                            <li>Teaches vocational skills and responsibility</li>
                            <li>Provides an opportunity to give back to the community and learn altruistic behavior</li>
                            <li>Promotes mental health</li>
                        </ul>

                        <h2 className='small-h2' tabIndex={0}>Benefits to Correctional Institutions</h2>
                        <ul>
                            <li>Boosts staff and resident morale</li>
                            <li>Provides an incentive for residents to modify their behavior</li>
                            <li>Enhances safe environments in prisons</li>
                            <li>Offers therapeutic support for residents with mental health issues or terminal illnesses
                            </li>
                        </ul>
                    </div>
                </div>
                <div className="d-xl-flex col-lg-6 px-lg-3">
                    <div className='pe-xl-2'>
                        <h2 className='small-h2' tabIndex={0}>Funding the Program</h2>
                        <p className="me-3">
                            P4P does not receive any general revenue funding from the state to support its activities.
                            Community members may donate to the program by visiting the official Missouri DOC donations
                            link:
                        </p>
                        <div className='pb-3 d-flex justify-content-center'>
                            <a role='button'
                                href="https://doc.mo.gov/programs/puppies-parole/donations"
                                target='_blank'
                                rel='noreferrer'
                                className='btn btn-outline-primary rounded-pill'
                            >
                                <svg xmlns="http://www.w3.org/2000/svg" width="1.25em" height="1.25em" viewBox="0 0 16 16" className="bi bi-cash" fill="currentColor">
                                    <path fillRule="evenodd" d="M15 4H1v8h14V4zM1 3a1 1 0 0 0-1 1v8a1 1 0 0 0 1 1h14a1 1 0 0 0 1-1V4a1 1 0 0 0-1-1H1z" />
                                    <path d="M13 4a2 2 0 0 0 2 2V4h-2zM3 4a2 2 0 0 1-2 2V4h2zm10 8a2 2 0 0 1 2-2v2h-2zM3 12a2 2 0 0 0-2-2v2h2zm7-4a2 2 0 1 1-4 0 2 2 0 0 1 4 0z" />
                                </svg>
                                <span className='ms-2'>Missouri P4P Donations</span>
                            </a>
                        </div>
                    </div>
                    <div id="imageContainer" className="text-center col-xl-6">
                        <img src={hankPic} className='rounded img-fluid'
                            alt="Dawg Days Show at JCCC" />
                    </div>
                </div>
            </div>
        </section>
    )
}

export default Donate;




















